export default {
  alaska: {
    name: 'Alaska Airlines',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Alaska-Airlines.zip',
  },
  alliant: {
    name: 'Alliant Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Alliant-Credit-Union.zip',
  },
  ally: {
    name: 'Ally Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Ally-Bank.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/American-Express.zip',
  },
  ascent: {
    name: 'Ascent',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Ascent.zip',
  },
  bofa: {
    name: 'Bank of America',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Bank-of-America.zip',
  },
  bethpage: {
    name: 'Bethpage Federal Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Bethpage-Federal-Credit-Union.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Capital-One.zip',
  },
  chase: {
    name: 'Chase',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Chase.zip',
  },
  citi: {
    name: 'Citibank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Citibank.zip',
  },
  collegeave: {
    name: 'College Ave',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/College-Ave.zip',
  },
  delta: {
    name: 'Delta',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Delta.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Discover.zip',
  },
  fidelity: {
    name: 'Fidelity Investments',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Fidelity-Investments.zip',
  },
  isl: {
    name: 'ISL',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/ISL.zip',
  },
  ladderlife: {
    name: 'Ladder Life',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Ladder-Life.zip',
  },
  laurelroad: {
    name: 'Laurel Road Refinance',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Laurel-Road-Refinance.zip',
  },
  lendingclub: {
    name: 'LendingClub',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/LendingClub.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/LightStream.zip',
  },
  mpower: {
    name: 'MPOWER',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/MPOWER.zip',
  },
  nbkc: {
    name: 'NBKC',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/NBKC.zip',
  },
  nasb: {
    name: 'North American Savings Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/North-American-Savings-Bank.zip',
  },
  pennymac: {
    name: 'PennyMac',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/PennyMac.zip',
  },
  risla: {
    name: 'RISLA Refinance',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/RISLA-Refinance.zip',
  },
  schwab: {
    name: 'Schwab Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Schwab-Bank.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/SoFi.zip',
  },
  statefarm: {
    name: 'State Farm',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/StateFarm.zip',
  },
  synchrony: {
    name: 'Synchrony Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Synchrony-bank.zip',
  },
  tdameritrade: {
    name: 'TD Ameritrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/TD-Ameritrade.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Upgrade.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/US-Bank.zip',
  },
  vanguard: {
    name: 'Vanguard',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Vanguard.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Wealthfront.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Wells-Fargo.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/World-of-Hyatt.zip',
  },
  zoefinancial: {
    name: 'Zoe Financial',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2023/badges/Zoe-Financial.zip',
  },
};
